import React from "react";
import Marquee from "react-fast-marquee";

const TopMarquee = () => {
  return (
    <div
      style={{
        backgroundColor: "#1A202C",
        color: "white",
        padding: "5px 0",
        fontSize: "0.8rem",
        fontWeight: "500",
      }}
    >
      <Marquee pauseOnHover={true} speed={60} gradient={false}>
        <span style={{ marginRight: "40px" }}>
          WE DELIVER TO....Cardiff, Bridgend, Newport, Barry, Porth, Pontypridd,
          Penarth, Rhondda, Tonypandy, Pontyclun, Aberdare, Mountain Ash,
          Treorchy, Treherbert And Tonyrefail
        </span>
      </Marquee>
    </div>
  );
};

export default TopMarquee;
